import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

document.addEventListener("DOMContentLoaded", function () {
    const dynamicTitle = document.querySelector(".dynamic-title"); // Target the correct span
    const titles = ["Data Engineer", "Analytics Engineer", "Data Analyst", "BI Engineer"]; // List of titles
    let currentTitleIndex = -1;
  
    function rotateTitle() {
      setInterval(() => {
        // Loop through the list of titles
        currentTitleIndex = (currentTitleIndex + 1) % titles.length;
        dynamicTitle.textContent = titles[currentTitleIndex]; // Change the text content
      }, 2000); // Change interval to adjust the speed of rotation
    }
  
    rotateTitle(); // Start the title rotation
  });
  